import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { useAbstractAddNewAlias } from '@/module/Author/Abstract/model/AbstractQuery';
import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { abstractMembershipOptions } from '@/module/Nomen/AbstractMembership/model/AbstractMembershipModel';

import { Id, useAppNotification } from '@feature/utils';

import { PublicationSearchClaimable } from '../Publication/PublicationSearchClaimable';

export function AbstractSearchClaimable() {
  const notification = useAppNotification();
  const navigate = useNavigate();

  const { data: memberships, isLoading, isError } = useQuery(abstractMembershipOptions.getAll());

  const mutation = useAbstractAddNewAlias();
  const onAddNewAlias = (publicationId: Id, request: PublicationNewAliasRequest) =>
    mutation.mutate(
      { abstractId: publicationId, request: request },
      {
        onSuccess: abstract => {
          notification.success();
          navigate({ to: '/author/abstract/$abstractId', params: { abstractId: String(abstract.id) } });
        },
        onError: notification.error,
      },
    );

  return (
    <PublicationSearchClaimable
      memberships={memberships}
      membershipsLoading={isLoading}
      membershipsError={isError}
      onAddNewAlias={onAddNewAlias}
    />
  );
}
